var map = {
	"./answer-lottery.svg": "2b9a",
	"./auction.svg": "3132",
	"./audio-connect.svg": "2a9d",
	"./audio-muted.svg": "25d0",
	"./audio.svg": "2d66",
	"./beauty.svg": "af15",
	"./camera-closed.svg": "ad99",
	"./camera.svg": "5b31",
	"./close.svg": "864a",
	"./copy.svg": "c0a5",
	"./edit.svg": "2fb0",
	"./emoji.svg": "3b1d",
	"./exit.svg": "a109",
	"./eye-open.svg": "74a2",
	"./eye.svg": "57fa",
	"./info-forbidden.svg": "a0d2",
	"./info.svg": "b888",
	"./language.svg": "a17a",
	"./mic.svg": "04f4",
	"./password.svg": "198d",
	"./red-pocket.svg": "8c34",
	"./setting.svg": "08d1",
	"./share.svg": "2296",
	"./shopping.svg": "98ab",
	"./user.svg": "d88a",
	"./video-connect.svg": "1368",
	"./video-muted.svg": "71ce"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";